'use client';

import { c as _c } from "react/compiler-runtime";
import useLiveSortState from '@module/helpers/live/useLiveSortState';
import useLiveViewModel from '@module/helpers/live/useLiveViewModel';
import BroadcastList from '@pc/components/molecules/broadcast/BroadcastList';
import BroadcastListSkeleton from '@pc/components/molecules/broadcast/BroadcastListSkeleton';
function LiveContainer() {
  const $ = _c(9);
  const {
    onlyNewBj,
    orderBy
  } = useLiveSortState();
  let t0;
  if ($[0] !== onlyNewBj || $[1] !== orderBy) {
    t0 = {
      onlyNewBj,
      orderBy
    };
    $[0] = onlyNewBj;
    $[1] = orderBy;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    data,
    isLoading,
    observerRef,
    fetchNextPage,
    hasNextPage
  } = useLiveViewModel(t0);
  if (isLoading || !data?.pages?.length) {
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <BroadcastListSkeleton />;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  let t1;
  if ($[4] !== data.pages || $[5] !== fetchNextPage || $[6] !== hasNextPage || $[7] !== observerRef) {
    t1 = <div id="live-container" data-testid="live-page"><BroadcastList className="live-page-list mr-0" list={data.pages} observerRef={observerRef} fetchNextPage={fetchNextPage} hasNextPage={hasNextPage} /></div>;
    $[4] = data.pages;
    $[5] = fetchNextPage;
    $[6] = hasNextPage;
    $[7] = observerRef;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
}
export default LiveContainer;